import { Component, Input } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';

export type InputMessageType = 'default' | 'error' | 'warning';
export interface InputMessage {
  message: string;
  params?: DataObject;
  type?: InputMessageType;
  show?: boolean;
}

@Component({
  selector: 'miq-input-message',
  template: `
    <div *ngIf="show" class="record-input-message-container">
      <div [ngClass]="['record-input-message', 'record-input-message--' + type]">
        {{ message | xTranslate: params }}
      </div>
    </div>
  `,
  styleUrls: ['./input-message.component.scss'],
  standalone: false,
})
export class InputMessageComponent {
  private _show: boolean = true;
  private _type: InputMessageType = 'default';

  @Input() message = '';
  @Input() params = {};

  @Input() set type(val: InputMessageType) {
    this._type = val ?? 'default';
  }
  @Input() set show(val: boolean) {
    this._show = val ?? true;
  }

  get show(): boolean {
    return this._show;
  }

  get type(): InputMessageType {
    return this._type;
  }
}
